import type { NavigationGuard } from 'vue-router';
import { useAuthStore } from '@/stores';
import { setRouteToGo } from '@shared/utils/popup';
import { useIsMobile } from '@shared/composables/useIsMobile';

export const guards: Record<string, NavigationGuard> = {
  checkIfLoggedIn: async (_to, _, next) => {
    const authStore = useAuthStore();

    if (authStore.$state.user?.id) {
      next();
      return;
    }

    await authStore.validateCookie();
    next();
  },
  mustBeLoggedIn: async (to, _, next) => {
    const authStore = useAuthStore();

    if (authStore.$state.user?.id) {
      next();
      return;
    }

    const userCached = await authStore.validateCookie();
    if (userCached) {
      next();
      return;
    }

    setRouteToGo(to.fullPath);

    if (!authStore.showLoginModal) {
      authStore.showLoginModal = true;
    }

    authStore.redirectToHomeOnCloseLoginModal = false;

    return;
  },

  mustBeLoggedOut: (_, __, next) => {
    const authStore = useAuthStore();

    if (!authStore.$state.user?.id) {
      next();
      return;
    }

    next({ path: '/' });
  },
  canEnterRoomUPM: (to, _, next) => {
    const authStore = useAuthStore();
    /*const { data } = await showcaseService.getProductBySlug(
      to.params.slug as string,
    );*/
    if (!(to.params.slug as string).toLowerCase().includes('upm')) {
      next();
      return;
    }

    if (authStore.user?.email.includes('@upm.es')) {
      next();
      return;
    }

    authStore.canDoModalProps.showCanDoModal = true;
    authStore.canDoModalProps.canDoTitle = 'Sala Privada';
    authStore.canDoModalProps.canDoMessage =
      'No tienes acceso a esta Sala. Continúa disfrutando del resto del contenido.';
    authStore.redirectToHomeOnCloseCanDoModal = false;

    return;
  },
  ssoMicrosoft: async (to, _, next) => {
    const authStore = useAuthStore();
    if (to.query.code) {
      if (!authStore.$state.user?.id) {
        await authStore.login('', '', 'microsoft', to.query.code as string);
      }
      next({ path: '/', replace: true });
      return;
    }
    next();
  },

  isProdEnvironment: (_, __, next) => {
    if (
      import.meta.env.VITE_ENV === 'dev' ||
      import.meta.env.VITE_ENV === 'staging'
    ) {
      next();
      return;
    } else {
      next({ path: '/' });
      return;
    }
  },

  // IMPORTANTE: Solamente se deja pasar en lab debido a que se está testeando el uso de juegos de Unity en mobile.
  // Una vez finalizado el testeo, se debe resolver si habilitarlo de forma permanente, o como proseguir.
  isMobile: (_, __, next) => {
    const env = import.meta.env.VITE_ENV;
    const { isMobile } = useIsMobile();

    // if (isMobile.value) {
    //   if (env === 'dev') {
    //     next();
    //     return;
    //   }
    //   useAuthStore().showComingSoonModal = true;
    //   next({ path: '/' });
    //   return;
    // }
    if (isMobile.value) {
      // Permite el acceso en entornos de desarrollo y staging
      if (env === 'dev') {
        next();
        return;
      }
      // if (
      //   to.path.startsWith('/collection/') &&
      //   !to.path.startsWith('/collection/games')
      // ) {
      //   useAuthStore().showComingSoonModal = true;
      //   next({ path: '/' });
      //   return;
      // }
    }
    next();
  },
};
